import LoadingOverlay from "react-loading-overlay-ts";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Modal, { Styles } from "react-modal";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import "../../../features/common/commonStyles.scss";
import fileDownload from "js-file-download";
import {
  changeActiveComponent,
  changeCurrentFilters,
  changePageState,
  createMultipleUsers,
  createRoleProfile,
  createUser,
  deleteMultipleUser,
  deleteRoleProfile,
  emptyGeneratedPassword,
  getFilteredUsers,
  getRoleOptions,
  getRoleProfiles,
  resetChangeUserData,
  resetOtherUserData,
  resetRoleProfiledata,
  selectActiveConfigurationComponent,
  selectChangeMultipleUsersError,
  selectChangeMultipleUsersLoading,
  selectCreateMultipleUsersResult,
  selectCreateUserError,
  selectCreateUserLoading,
  selectCurrentFilterRequestUsers,
  selectCurrentNumPagesUsers,
  selectCurrentPageUsers,
  selectCurrentRoles,
  selectGeneratedPassword,
  selectRoleOptions,
  selectRoleOptionsLoading,
  selectRoleProfiles,
  selectRPCreationError,
  selectRPCreationLoading,
  selectUsers,
  selectUsersLoading,
  setCurrentRoles,
  toggleMultipleUserStatus,
  updateRoleProfile,
} from "../configurationSlice";
import { ReactComponent as SortAlphaAsc } from "../../../Assets/common/images/sortAlphaAsc.svg";
import { ReactComponent as SortAlphaDesc } from "../../../Assets/common/images/sortAlphaDesc.svg";
import { ReactComponent as SortAsc } from "../../../Assets/common/images/sortAsc.svg";
import { ReactComponent as SortDesc } from "../../../Assets/common/images/sortDesc.svg";
import { useEffect, useState } from "react";
import { selectRoles, selectUserId } from "../../common/commonSlice";
import {
  formatDateStandar,
  formateDateRelativeToNow,
} from "../../../helpers/utils";
import { usePagination } from "pagination-react-js/dist/cjs/hooks/usePagination";
import PaginationItem from "../../../helpers/PaginationItem";
import {
  AddMultipleUsersReq,
  CreateUserRequest,
  CreateUserRequestError,
  RoleProfile,
  UserData,
} from "../configurationAPI";
import { ReactComponent as AddIcon } from "../../../Assets/common/images/addBlack.svg";
import { RolesComponent } from "./components/RolesComponent";
import isEmail from "validator/lib/isEmail";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { ExpandibleContent } from "../../services/components/ExpandibleContent";
import { DropDown } from "../../common/components/Btns/DropDown";
import * as XLSX from "xlsx";

Modal.setAppElement("#root");

const customStylesModalCreateUser: Styles = {
  content: {
    top: "50%",
    left: "60%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(255,255,255,1)",
    borderRadius: "20px",
    boxSizing: "border-box",
    padding: "1.2%",
    width: "75%",
    overflow: "auto",
  },
  overlay: {
    background: "rgba(0,0,0,0.3)",
  },
};

export const Users = () => {
  let usuarios = useAppSelector(selectUsers);
  let userId = useAppSelector(selectUserId);
  let currentPage = useAppSelector(selectCurrentPageUsers);
  let currentNumPages = useAppSelector(selectCurrentNumPagesUsers);
  let loadingStatus = useAppSelector(selectUsersLoading);
  let activeComponent = useAppSelector(selectActiveConfigurationComponent);
  let currentFilteredRequest = useAppSelector(selectCurrentFilterRequestUsers);
  const roleOptionsLoading = useAppSelector(selectRoleOptionsLoading);
  const roleOptions = useAppSelector(selectRoleOptions);
  const currentRoles = useAppSelector(selectCurrentRoles);
  const roles = useAppSelector(selectRoles);
  const rpCreationLoading = useAppSelector(selectRPCreationLoading);
  const rpCreationError = useAppSelector(selectRPCreationError);
  const createUserLoading = useAppSelector(selectCreateUserLoading);
  const createUserError = useAppSelector(selectCreateUserError);
  const createUserPassword = useAppSelector(selectGeneratedPassword);
  const createMultipleUsersResult = useAppSelector(
    selectCreateMultipleUsersResult
  );
  const changeMultipleUsersLoading = useAppSelector(
    selectChangeMultipleUsersLoading
  );
  const changeMultipleUsersError = useAppSelector(
    selectChangeMultipleUsersError
  );

  let dispatch = useAppDispatch();
  let navigate = useNavigate();

  //Select mutiple users
  const [selectedUsers, setSelectedUsers] = useState<UserData[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  const [modalCreateUserOpen, setModalCreateUserOpen] = useState(false);
  // user creation state
  const [multiple, setMultiple] = useState(false);
  // single user creation state
  const [singleUserCreate, setSingleUserCreate] = useState<CreateUserRequest>({
    email: "",
    name: "",
    phoneNumber: "",
    identification: "",
    roles: [],
    userName: "",
    userId: "",
  });
  const [singleUserPasswordRandom, setSingleUserPasswordRandom] =
    useState(true);
  const [singleUserCreateStep, setSingleUserCreateStep] = useState(0);
  const [singleUserCreateErrors, setSingleUserCreateErrors] = useState({
    emailError: "",
    nameError: "",
    phoneNumberError: "",
    identificationError: "",
    passwordError: "",
  });
  const [singleUserCreateRolesOption, setSingleUserCreateRolesOption] =
    useState<"SPECIFIC" | "ROLE_PROFILE" | "NONE">("NONE");
  const [
    singleUserCreateRoleProfileFromRoles,
    setSingleUserCreateRoleProfileFromRoles,
  ] = useState<boolean>(false);
  const [copied, setCopied] = useState(false);
  // multiple user creation state
  const [multipleUserCreate, setMultipleUserCreate] = useState<
    CreateUserRequest[]
  >([]);
  const [errorMultipleUserCreate, setErrorMultipleUserCreate] = useState<
    CreateUserRequestError[]
  >([]);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [multipleUserPasswordRandom, setMultipleUserPasswordRandom] =
    useState(true);
  const [multipleUserForcedPassword, setMultipleUserForcedPassword] = useState<{
    password?: string;
    passwordError: string;
  }>({ password: "", passwordError: "" });
  const [multipleUserGeneralError, setMultipleUserGeneralError] =
    useState<string>("");
  // role profile state
  const roleProfiles = useAppSelector(selectRoleProfiles);
  const [modalRoleProfilesOpen, setModalRoleProfilesOpen] = useState(false);
  // role profile creation state
  const [modalRoleCreateOpen, setModalRoleCreateOpen] = useState(false);
  const [newRoleProfile, setNewRoleProfile] = useState<RoleProfile | undefined>(
    undefined
  );

  const checkMultipleUserCreation = () => {
    const emailsWithoutRoleProfile: string[] = [];
    for (let i = 0; i < multipleUserCreate.length; i++) {
      if (!multipleUserCreate[i].roleProfileId) {
        emailsWithoutRoleProfile.push(multipleUserCreate[i].email);
      }
    }
    if (multipleUserCreate.length === 0) {
      setMultipleUserGeneralError("No hay usuarios para crear");
      return false;
    } else if (emailsWithoutRoleProfile.length > 0) {
      setMultipleUserGeneralError(
        `Los siguientes correos no tienen un rol, puede seleccionarlo en el desplegable: ${emailsWithoutRoleProfile.join(
          ", "
        )}`
      );
      return false;
    } else {
      setMultipleUserGeneralError("");
      return true;
    }
  };

  const multipleUserCreationModule = () => {
    if (createMultipleUsersResult) {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginTop: "20px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 2px 0",
            }}
          >
            A continuación se muestra el resultado de la creación de los
            usuarios. También puedes descargar esta información en un archivo
            excel dando click en el siguiente boton.
          </p>
          <button
            style={{
              background: "#1A617D",
              padding: "7px 15px 7px 15px",
              borderRadius: "8px",
              border: "none",
              color: "white",
              margin: "10px 0",
              fontWeight: "600",
              fontSize: "14px",
              width: "280px",
              alignSelf: "center",
            }}
            onClick={() => {
              let url = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${createMultipleUsersResult.excelResult}`;

              fetch(url)
                .then((res) => res.blob())
                .then((blob) => {
                  fileDownload(blob, `Reporte creación de usuarios.xlsx`);
                });
            }}
          >
            Descargar usuarios creados
          </button>
          {createMultipleUsersResult.createdUsers.length > 0 && (
            <h5 style={{ fontSize: "14px", fontWeight: 700, color: "black" }}>
              Usuarios agregados correctamente:{" "}
              {createMultipleUsersResult.createdUsers.length}
            </h5>
          )}
          {createMultipleUsersResult.createdUsers.length > 0 && (
            <div
              style={{
                width: "100%",
                height: "150px",
                overflowY: "auto",
                display: "flex",
                justifyContent: "start",
                flexDirection: "column",
              }}
            >
              <table style={{ width: "100%" }}>
                <thead>
                  <tr style={{ fontSize: "12px" }}>
                    <th></th>
                    <th>Usuario</th>
                    <th>Contraseña</th>
                  </tr>
                </thead>
                <tbody>
                  {createMultipleUsersResult.createdUsers.map((user, index) => {
                    return (
                      <tr key={index} style={{ fontSize: "14px" }}>
                        <td></td>
                        <td>{user.username}</td>
                        <td>{user.password}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {createMultipleUsersResult.failedUsers.length > 0 && (
            <h5
              style={{
                fontSize: "14px",
                marginBottom: "0",
                fontWeight: 700,
                color: "black",
              }}
            >
              Usuarios que generaron errores en la creación:{" "}
              {createMultipleUsersResult.failedUsers.length}
            </h5>
          )}
          {createMultipleUsersResult.failedUsers.length > 0 && (
            <div
              style={{
                width: "100%",
                height: "150px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <table style={{ width: "100%" }}>
                <thead>
                  <tr style={{ fontSize: "12px" }}>
                    <th></th>
                    <th>Usuario</th>
                    <th>Motivo de error</th>
                  </tr>
                </thead>
                <tbody>
                  {createMultipleUsersResult.failedUsers.map((user, index) => {
                    return (
                      <tr key={index} style={{ fontSize: "14px" }}>
                        <td></td>
                        <td>{user.username}</td>
                        <td style={{ color: "rgb(212, 0, 11)" }}>
                          {user.errorMessage}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>{" "}
            </div>
          )}
          <div
            className="flex-row"
            style={{
              width: "70%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "10px",
              alignSelf: "center",
            }}
          >
            <button
              onClick={(e) => {
                setModalCreateUserOpen(false);
                setMultipleUserCreate([]);
                setErrorMultipleUserCreate([]);
                setMultipleUserForcedPassword({
                  password: undefined,
                  passwordError: "",
                });
                setMultipleUserPasswordRandom(true);
                dispatch(emptyGeneratedPassword());
                e.preventDefault();
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "35%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              Finalizar
            </button>
          </div>
        </div>
      );
    } else {
      const roptions = roleProfiles.map((rp) => {
        return {
          label: rp.name!,
          value: rp.id!,
        };
      });

      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            marginTop: "20px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "500",
              textAlign: "center",
              margin: "0 0 2px 0",
            }}
          >
            Adjunte a continuación un archivo CSV o excel con la estructura
            mostrada en {""}
            <a
              href="https://cdn.anteia.co/downloadables/FormatoCreacionMultiplesUsuarios.xlsx"
              target="_blank"
              rel="noreferrer"
              style={{ color: "#0d6efd", textDecoration: "underline" }}
            >
              este ejemplo.
            </a>
            <br />
            <span>
              Los titulos de las columnas pueden ser diferentes, sin embargo la
              estructura del documento debe ser la misma
            </span>
          </p>
          <label
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              borderRadius: "8px",
              padding: "7px 14px",
              background: "#1A617D",
              alignSelf: "center",
              margin: "10px auto",
            }}
            htmlFor="fileInput"
          >
            <input
              style={{
                display: "none",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
              onChange={async (e) => {
                let file = e.target.files ? e.target.files[0] : null;
                let type = "";
                if (file) {
                  type = file.type;
                  const reader = new FileReader();

                  try {
                    if (
                      type === "text/csv" ||
                      type === "text/plain" ||
                      type === "application/vnd.ms-excel"
                    ) {
                      reader.onload = async (e) => {
                        if (e.target && e.target.result) {
                          const text = e.target.result as string;
                          const lines = text.trim().split("\n");

                          const dataRows = lines.slice(1).map((line) => {
                            return line.split(",").map((value) => value.trim());
                          });
                          const emailsUsed: string[] = [];
                          const usersToCreate = [] as CreateUserRequest[];
                          const rejectedUsers = [] as CreateUserRequestError[];
                          for (let i = 1; i < dataRows.length; i++) {
                            const row = dataRows[i] as unknown[];
                            const profileName = row[4] as string;
                            const profile = roleProfiles.find(
                              (p) => p.name === profileName
                            );
                            const userAdded = emailsUsed.includes(
                              row[1] as string
                            );
                            emailsUsed.push(row[1] as string);
                            let esAsesor = false;
                            let esAsesorCell = row[5] as string;
                            if (
                              esAsesorCell === "Si" ||
                              esAsesorCell === "si" ||
                              esAsesorCell === "SI"
                            ) {
                              esAsesor = true;
                            }
                            if (
                              !roles.includes("SuperAdmin") &&
                              !isEmail(row[1] as string)
                            ) {
                              const user: CreateUserRequestError = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                motive: "Email inválido",
                                setAsesor: esAsesor,
                              };
                              rejectedUsers.push(user);
                            } else if (userAdded) {
                              const user: CreateUserRequestError = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                motive: "Usuario repetido",
                                setAsesor: esAsesor,
                              };
                              rejectedUsers.push(user);
                            } else if (
                              (row[0] as string) === "" ||
                              (row[0] as string) === undefined
                            ) {
                              const user: CreateUserRequestError = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                motive: "Falta nombre",
                                setAsesor: esAsesor,
                              };
                              rejectedUsers.push(user);
                            } else {
                              const user: CreateUserRequest = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                setAsesor: esAsesor,
                              };
                              usersToCreate.push(user);
                            }
                          }
                          if (usersToCreate.length > 0) {
                            setMultipleUserCreate(usersToCreate);
                          }
                          if (rejectedUsers.length > 0) {
                            setErrorMultipleUserCreate(rejectedUsers);
                          }
                        } else {
                          setFileErrorMessage("Formato no soportado");
                        }
                      };
                      reader.readAsText(file);
                      setFileErrorMessage("");
                    } else if (
                      type ===
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    ) {
                      reader.onload = (e) => {
                        if (e.target && e.target.result) {
                          const data = new Uint8Array(
                            e.target.result as ArrayBuffer
                          );
                          const workbook = XLSX.read(data, { type: "array" });
                          const sheetName = workbook.SheetNames[0];
                          const sheet = workbook.Sheets[sheetName];
                          const jsonData = XLSX.utils.sheet_to_json(sheet, {
                            defval: "",
                            header: 1,
                          }) as [][];
                          const emailsUsed: string[] = [];
                          const usersToCreate = [] as CreateUserRequest[];
                          const rejectedUsers = [] as CreateUserRequestError[];
                          for (let i = 1; i < jsonData.length; i++) {
                            const row = jsonData[i] as unknown[];
                            const profileName = row[4] as string;
                            const profile = roleProfiles.find(
                              (p) => p.name === profileName
                            );
                            const userAdded = emailsUsed.includes(
                              row[1] as string
                            );
                            emailsUsed.push(row[1] as string);
                            let esAsesor = false;
                            let esAsesorCell = row[5] as string;
                            if (
                              esAsesorCell === "Si" ||
                              esAsesorCell === "si" ||
                              esAsesorCell === "SI"
                            ) {
                              esAsesor = true;
                            }
                            if (
                              !roles.includes("SuperAdmin") &&
                              !isEmail(row[1] as string)
                            ) {
                              const user: CreateUserRequestError = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                motive: "Email inválido",
                                setAsesor: esAsesor,
                              };
                              rejectedUsers.push(user);
                            } else if (userAdded) {
                              const user: CreateUserRequestError = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                motive: "Usuario repetido",
                                setAsesor: esAsesor,
                              };
                              rejectedUsers.push(user);
                            } else if (
                              (row[0] as string) === "" ||
                              (row[0] as string) === undefined
                            ) {
                              const user: CreateUserRequestError = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                motive: "Falta nombre",
                                setAsesor: esAsesor,
                              };
                              rejectedUsers.push(user);
                            } else {
                              const user: CreateUserRequest = {
                                name: row[0] as string,
                                email: row[1] as string,
                                identification: row[2] as string,
                                phoneNumber: row[3] as string,
                                userName: "",
                                roles: [],
                                userId: "",
                                roleProfileId: profile?.id,
                                setAsesor: esAsesor,
                              };
                              usersToCreate.push(user);
                            }
                          }
                          if (usersToCreate.length > 0) {
                            setMultipleUserCreate(usersToCreate);
                          }
                          if (rejectedUsers.length > 0) {
                            setErrorMultipleUserCreate(rejectedUsers);
                          }
                          setFileErrorMessage("");
                        } else {
                          setFileErrorMessage("Formato no soportado");
                        }
                      };

                      reader.readAsArrayBuffer(file);
                    } else {
                      setFileErrorMessage("Formato no soportado");
                    }

                    reader.onerror = (e) => {
                      setFileErrorMessage("Formato no soportado");
                    };
                  } catch (e) {
                    setFileErrorMessage("Formato no soportado");
                  }
                } else {
                  setFileErrorMessage("No se ha seleccionado un archivo");
                }
              }}
              type="file"
              id="fileInput"
            />

            <div
              style={{
                fontSize: "14px",
                fontWeight: 700,
                color: "white",
              }}
            >
              Agregar desde un archivo excel/csv
            </div>
          </label>
          {fileErrorMessage && (
            <p
              style={{
                color: "rgb(212, 0, 11)",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              {fileErrorMessage}{" "}
            </p>
          )}
          {multipleUserCreate.length > 0 && (
            <h5 style={{ fontSize: "14px", fontWeight: 700, color: "black" }}>
              Usuarios a agregar
            </h5>
          )}
          {multipleUserCreate.length > 0 && (
            <div
              style={{
                width: "100%",
                height: "150px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <table style={{ width: "100%", overflow: "auto" }}>
                <thead>
                  <tr style={{ fontSize: "12px" }}>
                    <th></th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Identificación</th>
                    <th>Teléfono</th>
                    <th>Rol</th>
                    <th>¿Es Asesor?</th>
                    <th>Eliminar de la lista</th>
                  </tr>
                </thead>
                <tbody>
                  {multipleUserCreate.map((user, index) => {
                    let roleProfileShow: string | JSX.Element = "";
                    const roleP = roleProfiles.find(
                      (r) => r.id === user.roleProfileId
                    );
                    let defaultOption = undefined;
                    if (roleP) {
                      defaultOption = {
                        value: roleP.id!,
                        label: roleP.name!,
                      };
                    }
                    roleProfileShow = (
                      <DropDown
                        key={"roleProfileShow"}
                        title=""
                        options={roptions}
                        onChange={(e) => {
                          if (e && e.value) {
                            setMultipleUserCreate((prevUsers) =>
                              prevUsers.map((u) =>
                                u.email === user.email
                                  ? { ...u, roleProfileId: e.value }
                                  : u
                              )
                            );
                          }
                        }}
                        isClearable
                        defaultValue={defaultOption}
                        bgColor="#1a617d"
                      />
                    );

                    const esAsesorOptions = [
                      { value: "true", label: "Si" },
                      { value: "false", label: "No" },
                    ];
                    let defaultOptionEsAsesor = {
                      value: "false",
                      label: "No",
                    };
                    if (user.setAsesor) {
                      defaultOptionEsAsesor = {
                        value: "true",
                        label: "Si",
                      };
                    }
                    const esAsesorShow = (
                      <DropDown
                        key={"esAsesorShow"}
                        title=""
                        options={esAsesorOptions}
                        onChange={(e) => {
                          if (e && e.value) {
                            setMultipleUserCreate((prevUsers) =>
                              prevUsers.map((u) =>
                                u.email === user.email
                                  ? {
                                      ...u,
                                      setAsesor:
                                        e.value === "true" ? true : false,
                                    }
                                  : u
                              )
                            );
                          }
                        }}
                        isClearable
                        defaultValue={defaultOptionEsAsesor}
                        bgColor="#1a617d"
                      />
                    );

                    const buttonDelete = (
                      <button
                        type="button"
                        style={{
                          backgroundColor: "transparent",
                          border: "1px solid #cf4259",
                          borderRadius: "5px",
                          color: "#cf4259",
                          display: "inline-block",
                          cursor: "pointer",
                          padding: "4px 10px",
                          fontSize: "14px",
                          fontWeight: 600,
                        }}
                        onClick={() => {
                          setMultipleUserCreate((prevUsers) =>
                            prevUsers.filter((u) => u.email !== user.email)
                          );
                        }}
                      >
                        Eliminar
                      </button>
                    );

                    return (
                      <tr key={index} style={{ fontSize: "14px" }}>
                        <td></td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.identification}</td>
                        <td>{user.phoneNumber}</td>
                        <td>{roleProfileShow}</td>
                        <td>{esAsesorShow}</td>
                        <td>{buttonDelete}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {multipleUserGeneralError && (
            <p
              style={{
                color: "rgb(212, 0, 11)",
                fontSize: "12px",
                textAlign: "end",
                marginBottom: "5px",
              }}
            >
              {multipleUserGeneralError}{" "}
            </p>
          )}
          {createUserError && (
            <p
              style={{
                color: "rgb(212, 0, 11)",
                fontSize: "15px",
                textAlign: "center",
                marginBottom: "5px",
              }}
            >
              {`Error creando usuario: ${createUserError}`}{" "}
            </p>
          )}
          {multipleUserCreate.length > 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "12px",
                marginBottom: "15px",
                width: "50%",
              }}
            >
              <FormControlLabel
                style={{
                  color: "#000",
                  width: "90%",
                  margin: "5px 0 5px 0px",
                  fontFamily: "Open Sans",
                }}
                control={
                  <Checkbox
                    style={{ color: "#000", alignSelf: "start" }}
                    checked={!multipleUserPasswordRandom}
                    onChange={() => {
                      if (!multipleUserPasswordRandom) {
                        setMultipleUserForcedPassword({
                          ...multipleUserForcedPassword,
                          password: "",
                          passwordError: "",
                        });
                      }

                      setMultipleUserPasswordRandom((x) => !x);
                    }}
                  />
                }
                label={
                  <span
                    style={{
                      fontFamily: "Open Sans",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    ¿Ingresar contraseña personalizada para todos los usuarios?
                    (si no se ingresa, se generara una aleatoria)
                  </span>
                }
              />
              {!multipleUserPasswordRandom && (
                <label
                  htmlFor="passwordUserMultiple"
                  style={{
                    width: "60%",
                    marginRight: "10px",
                    alignSelf: "start",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Contraseña
                  </p>
                  <input
                    onChange={(e) => {
                      if (e.target.value.length <= 8) {
                        setMultipleUserForcedPassword({
                          ...multipleUserForcedPassword,
                          passwordError:
                            "La contrasena debe tener al menos 8 caracteres",
                          password: e.target.value,
                        });
                      } // password must contain a special character
                      else if (
                        !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
                          e.target.value
                        )
                      ) {
                        setMultipleUserForcedPassword({
                          ...multipleUserForcedPassword,
                          passwordError:
                            "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())",
                          password: e.target.value,
                        });
                      } // password must contain a number
                      else if (!/[0-9]/.test(e.target.value)) {
                        setMultipleUserForcedPassword({
                          ...multipleUserForcedPassword,
                          passwordError:
                            "La contrasena debe contener por lo menos un número",
                          password: e.target.value,
                        });
                      } else {
                        setMultipleUserForcedPassword({
                          ...multipleUserForcedPassword,
                          passwordError: "",
                          password: e.target.value,
                        });
                      }
                    }}
                    id="passwordUserMultiple"
                    name="passwordUserMultiple"
                    type="text"
                    placeholder="Contraseña segura"
                    value={multipleUserForcedPassword.password || ""}
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                  {multipleUserForcedPassword.passwordError && (
                    <p
                      style={{
                        fontSize: "11px",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                        fontWeight: "500",
                        color: "#cf4259",
                      }}
                    >
                      {multipleUserForcedPassword.passwordError}
                    </p>
                  )}
                </label>
              )}
            </div>
          )}
          {errorMultipleUserCreate.length > 0 && (
            <h5
              style={{
                fontSize: "14px",
                marginBottom: "0",
                fontWeight: 700,
                color: "black",
              }}
            >
              Usuarios que no se pueden crear
            </h5>
          )}
          {errorMultipleUserCreate.length > 0 && (
            <div
              style={{
                width: "100%",
                height: "150px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <table style={{ width: "100%", overflow: "auto" }}>
                <thead>
                  <tr style={{ fontSize: "12px" }}>
                    <th></th>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th>Identificación</th>
                    <th>Teléfono</th>
                    <th>Motivo de rechazo</th>
                  </tr>
                </thead>
                <tbody>
                  {errorMultipleUserCreate.map((user, index) => {
                    return (
                      <tr key={index} style={{ fontSize: "14px" }}>
                        <td></td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{user.identification}</td>
                        <td>{user.phoneNumber}</td>
                        <td style={{ color: "rgb(212, 0, 11)" }}>
                          {user.motive}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <button
                style={{
                  background: "#1A617D",
                  padding: "7px 15px 7px 15px",
                  borderRadius: "8px",
                  border: "none",
                  color: "white",
                  minWidth: "150px",
                  fontWeight: "600",
                }}
                onClick={() => {
                  setErrorMultipleUserCreate([]);
                }}
              >
                Ignorar usuarios inválidos
              </button>
            </div>
          )}
          <div
            className="flex-row"
            style={{
              width: "80%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "10px",
              alignSelf: "center",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setModalCreateUserOpen(false);
                setMultipleUserCreate([]);
                setErrorMultipleUserCreate([]);
                setMultipleUserForcedPassword({
                  password: undefined,
                  passwordError: "",
                });
                setMultipleUserPasswordRandom(true);
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "35%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cancelar
            </button>
            <button
              disabled={createUserLoading === "pending"}
              onClick={(e) => {
                e.preventDefault();
                if (checkMultipleUserCreation()) {
                  const req: AddMultipleUsersReq = {
                    users: multipleUserCreate,
                    forcedPassword: multipleUserForcedPassword.password,
                  };
                  dispatch(createMultipleUsers(req)).then((x) => {
                    if (x.meta.requestStatus === "fulfilled") {
                      dispatch(getFilteredUsers(currentFilteredRequest));
                    }
                  });
                }
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "35%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {createUserLoading === "pending" ? (
                <ClipLoader color="white" size={"20px"} />
              ) : (
                "Crear Usuarios"
              )}
            </button>
          </div>
        </div>
      );
    }
  };

  const singleUserCreateRoleProfile = () => {
    if (roleOptionsLoading === "pending") {
      return <ClipLoader color={"#fff"} loading={true} size={35} />;
    } else {
      const options = roleProfiles.map((rp) => {
        return {
          label: rp.name!,
          value: rp.id!,
        };
      });
      return (
        <DropDown
          key={"roleProfile"}
          title=""
          maxContent
          options={options}
          onChange={(e) => {
            if (!e || e?.value === undefined) {
              setSingleUserCreate({
                ...singleUserCreate,
                roleProfileId: undefined,
              });
            }
            if (e?.value === "") {
              setSingleUserCreate({
                ...singleUserCreate,
                roleProfileId: undefined,
              });
            } else {
              setSingleUserCreate({
                ...singleUserCreate,
                roleProfileId: e?.value,
              });
            }
          }}
        />
      );
    }
  };

  const canFinishBasicInfo = () => {
    if (singleUserCreate.email.length === 0) {
      return false;
    }
    if (singleUserCreateErrors.emailError.length > 0) {
      return false;
    }
    if (singleUserCreate.name.length === 0) {
      return false;
    }
    if (singleUserCreateErrors.nameError.length > 0) {
      return false;
    }
    if (singleUserCreateErrors.identificationError.length > 0) {
      return false;
    }
    if (singleUserCreateErrors.phoneNumberError.length > 0) {
      return false;
    }
    if (
      !singleUserPasswordRandom &&
      singleUserCreateErrors.passwordError.length > 0
    ) {
      return false;
    }
    return true;
  };

  const canCreateSingleUser = () => {
    if (canFinishBasicInfo()) {
      if (currentRoles.length > 0) {
        if (
          singleUserCreateRoleProfileFromRoles &&
          canCreateOrUpdateRoleProfile()
        ) {
          return true;
        } else if (!singleUserCreateRoleProfileFromRoles) {
          return true;
        } else {
          return false;
        }
      } else if (singleUserCreate.roleProfileId) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const singleUserCreationModule = () => {
    switch (singleUserCreateStep) {
      case 0:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
                textAlign: "center",
                margin: "0 0 2px 0",
              }}
            >
              Ingrese la siguiente información básica del usuario <br />
              (los campos con "*" son obligatorios).
            </p>
            <div
              className="flex-col"
              style={{
                width: "100%",
                alignItems: "center",
                marginTop: "5px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "12px",
                  width: "50%",
                  alignSelf: "center",
                }}
              >
                <label
                  htmlFor="nameUser"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    alignSelf: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Nombre del usuario *
                  </p>
                  <input
                    onChange={(e) => {
                      if (e.target.value.length > 40) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          nameError:
                            "El nombre debe tener menos de 40 caracteres",
                        });
                      } else if (e.target.value.length === 0) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          nameError: "El nombre no puede estar vacío",
                        });
                      } else {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          nameError: "",
                        });
                      }
                      setSingleUserCreate({
                        ...singleUserCreate,
                        name: e.target.value,
                      });
                    }}
                    id="nameUser"
                    name="nameUser"
                    type="text"
                    placeholder="Nombre"
                    value={singleUserCreate.name}
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                  {singleUserCreateErrors.nameError && (
                    <p
                      style={{
                        fontSize: "11px",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                        fontWeight: "500",
                        color: "#cf4259",
                      }}
                    >
                      {singleUserCreateErrors.nameError}
                    </p>
                  )}
                </label>
                <label
                  htmlFor="emailUser"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    alignSelf: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Correo del usuario *
                  </p>
                  <input
                    onChange={(e) => {
                      if (
                        !roles.includes("SuperAdmin") &&
                        !isEmail(e.target.value)
                      ) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          emailError: "Ingrese un correo electronico válido",
                        });
                      } else if (e.target.value.length === 0) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          emailError: "El correo no puede estar vacío",
                        });
                      } else {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          emailError: "",
                        });
                      }
                      setSingleUserCreate({
                        ...singleUserCreate,
                        email: e.target.value,
                      });
                    }}
                    id="nameUser"
                    name="nameUser"
                    type="text"
                    placeholder="Correo Electronico"
                    value={singleUserCreate.email}
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                  {singleUserCreateErrors.emailError && (
                    <p
                      style={{
                        fontSize: "11px",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                        fontWeight: "500",
                        color: "#cf4259",
                      }}
                    >
                      {singleUserCreateErrors.emailError}
                    </p>
                  )}
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "12px",
                  width: "50%",
                  alignSelf: "center",
                }}
              >
                <label
                  htmlFor="identificationUser"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    alignSelf: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Identificación
                  </p>
                  <input
                    onChange={(e) => {
                      if (e.target.value.length > 20) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          identificationError:
                            "La identificación debe tener menos de 20 caracteres",
                        });
                      } else if (
                        e.target.value.length !== 0 &&
                        e.target.value.length < 8
                      ) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          identificationError:
                            "La identificación debe tener al menos 8 caracteres",
                        });
                      } else {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          identificationError: "",
                        });
                      }
                      setSingleUserCreate({
                        ...singleUserCreate,
                        identification: e.target.value,
                      });
                    }}
                    id="identificatonUser"
                    name="identificatonUser"
                    type="text"
                    placeholder="Opcional"
                    value={singleUserCreate.identification}
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                  {singleUserCreateErrors.identificationError && (
                    <p
                      style={{
                        fontSize: "11px",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                        fontWeight: "500",
                        color: "#cf4259",
                      }}
                    >
                      {singleUserCreateErrors.identificationError}
                    </p>
                  )}
                </label>
                <label
                  htmlFor="phoneNumberUser"
                  style={{
                    width: "100%",
                    marginRight: "10px",
                    alignSelf: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "start",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#000",
                      fontWeight: "500",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Número de Telefono
                  </p>
                  <input
                    onChange={(e) => {
                      if (
                        e.target.value.length !== 0 &&
                        e.target.value.length < 8
                      ) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          phoneNumberError:
                            "El telefono debe tener al menos 8 caracteres",
                        });
                      } else if (e.target.value.length > 16) {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          phoneNumberError:
                            "El telefono debe tener menos de 16 caracteres",
                        });
                      } else {
                        setSingleUserCreateErrors({
                          ...singleUserCreateErrors,
                          phoneNumberError: "",
                        });
                      }
                      setSingleUserCreate({
                        ...singleUserCreate,
                        phoneNumber: e.target.value,
                      });
                    }}
                    id="phoneNumberUser"
                    name="phoneNumberUser"
                    type="text"
                    placeholder="Opcional"
                    value={singleUserCreate.phoneNumber}
                    style={{
                      border: "1px solid rgba(0,0,0,0.5)",
                      borderRadius: "6px",
                      background: "transparent",
                      padding: "8px 8px 8px 8px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "500",
                      textAlign: "start",
                      color: "#000",
                      width: "100%",
                    }}
                  />
                  {singleUserCreateErrors.phoneNumberError && (
                    <p
                      style={{
                        fontSize: "11px",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                        fontWeight: "500",
                        color: "#cf4259",
                      }}
                    >
                      {singleUserCreateErrors.phoneNumberError}
                    </p>
                  )}
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "12px",
                  marginBottom: "15px",
                  width: "50%",
                  alignSelf: "center",
                }}
              >
                <FormControlLabel
                  style={{
                    color: "#000",
                    width: "90%",
                    margin: "5px 0 5px 0px",
                    fontFamily: "Open Sans",
                  }}
                  control={
                    <Checkbox
                      style={{ color: "#000", alignSelf: "start" }}
                      checked={!singleUserPasswordRandom}
                      onChange={() => {
                        if (!singleUserPasswordRandom) {
                          setSingleUserCreate({
                            ...singleUserCreate,
                            password: "",
                          });
                          setSingleUserCreateErrors({
                            ...singleUserCreateErrors,
                            passwordError: "",
                          });
                        }

                        setSingleUserPasswordRandom((x) => !x);
                      }}
                    />
                  }
                  label={
                    <span
                      style={{
                        fontFamily: "Open Sans",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      ¿Ingresar contraseña personalizada? (si no se ingresa, se
                      generara una aleatoria)
                    </span>
                  }
                />
                {!singleUserPasswordRandom && (
                  <label
                    htmlFor="passwordUser"
                    style={{
                      width: "60%",
                      marginRight: "10px",
                      alignSelf: "start",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "start",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "13px",
                        color: "#000",
                        fontWeight: "500",
                        textAlign: "start",
                        margin: "0 0 2px 2px",
                      }}
                    >
                      Contraseña
                    </p>
                    <input
                      onChange={(e) => {
                        if (e.target.value.length <= 8) {
                          setSingleUserCreateErrors({
                            ...singleUserCreateErrors,
                            passwordError:
                              "La contrasena debe tener al menos 8 caracteres",
                          });
                        } // password must contain a special character
                        else if (
                          !/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(
                            e.target.value
                          )
                        ) {
                          setSingleUserCreateErrors({
                            ...singleUserCreateErrors,
                            passwordError:
                              "La contrasena debe contener por lo menos un caracter especial (!@#$%&*())",
                          });
                        } // password must contain a number
                        else if (!/[0-9]/.test(e.target.value)) {
                          setSingleUserCreateErrors({
                            ...singleUserCreateErrors,
                            passwordError:
                              "La contrasena debe contener por lo menos un número",
                          });
                        } else {
                          setSingleUserCreateErrors({
                            ...singleUserCreateErrors,
                            passwordError: "",
                          });
                        }
                        setSingleUserCreate({
                          ...singleUserCreate,
                          password: e.target.value,
                        });
                      }}
                      id="passwordUser"
                      name="passwordUser"
                      type="text"
                      placeholder="Contraseña segura"
                      value={singleUserCreate.password}
                      style={{
                        border: "1px solid rgba(0,0,0,0.5)",
                        borderRadius: "6px",
                        background: "transparent",
                        padding: "8px 8px 8px 8px",
                        minHeight: "24px",
                        fontSize: "12px",
                        fontWeight: "500",
                        textAlign: "start",
                        color: "#000",
                        width: "100%",
                      }}
                    />
                    {singleUserCreateErrors.passwordError && (
                      <p
                        style={{
                          fontSize: "11px",
                          textAlign: "start",
                          margin: "0 0 2px 2px",
                          fontWeight: "500",
                          color: "#cf4259",
                        }}
                      >
                        {singleUserCreateErrors.passwordError}
                      </p>
                    )}
                  </label>
                )}
                <FormControlLabel
                  style={{
                    color: "#000",
                    width: "90%",
                    margin: "5px 0 5px 0px",
                    fontFamily: "Open Sans",
                  }}
                  control={
                    <Checkbox
                      style={{ color: "#000", alignSelf: "start" }}
                      checked={singleUserCreate.setAsesor || false}
                      onChange={() => {
                        let value = false;
                        if (!singleUserCreate.setAsesor) {
                          value = true;
                        }
                        setSingleUserCreate({
                          ...singleUserCreate,
                          setAsesor: value,
                        });
                      }}
                    />
                  }
                  label={
                    <span
                      style={{
                        fontFamily: "Open Sans",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      Asignar como asesor
                    </span>
                  }
                />
              </div>
            </div>
            <div
              className="flex-row"
              style={{
                width: "80%",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "10px",
                alignSelf: "center",
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setSingleUserCreate({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    identification: "",
                    password: "",
                    roles: [],
                    roleProfileId: "",
                    userName: "",
                    userId: "",
                    setAsesor: undefined,
                  });
                  setSingleUserCreateErrors({
                    emailError: "",
                    nameError: "",
                    identificationError: "",
                    passwordError: "",
                    phoneNumberError: "",
                  });
                  setSingleUserCreateRoleProfileFromRoles(false);
                  setModalCreateUserOpen(false);
                  setSingleUserPasswordRandom(true);
                  setMultipleUserPasswordRandom(true);
                  setNewRoleProfile(undefined);
                  dispatch(resetRoleProfiledata());
                }}
                className="flex-col text-medium text-bold"
                style={{
                  background: "transparent",
                  width: "35%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "1px solid #1A617D",
                  color: "#1A617D",
                }}
              >
                Cancelar
              </button>
              <button
                disabled={!canFinishBasicInfo()}
                onClick={(e) => {
                  e.preventDefault();
                  setSingleUserCreateStep(1);
                }}
                className="flex-col text-medium text-bold primary-color"
                style={{
                  background: "#1A617D",
                  width: "35%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "none",
                }}
              >
                Continuar
              </button>
            </div>
          </div>
        );
      case 1:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            {roleProfiles && roleProfiles.length > 0 ? (
              <p
                style={{
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "500",
                  textAlign: "center",
                  margin: "0 0 15px 0",
                }}
              >
                A continuación, debes asignar al usuario los permisos que va a
                tener el usuario en la plataforma.
                <br /> Puedes seleccionar un rol de permisos o permisos
                específicos para este usuario.
              </p>
            ) : (
              <p
                style={{
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "500",
                  textAlign: "center",
                  margin: "0 0 15px 0",
                }}
              >
                A continuación, debes asignar al usuario los permisos que va a
                tener el usuario en la plataforma.
              </p>
            )}
            {rpCreationError && (
              <p
                style={{
                  fontSize: "13px",
                  color: "#cf4259",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                {rpCreationError}
              </p>
            )}
            {createUserError && (
              <p
                style={{
                  fontSize: "16px",
                  color: "#cf4259",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                {createUserError}
              </p>
            )}
            <ExpandibleContent
              title={"Permisos específicos"}
              isActive={singleUserCreateRolesOption === "SPECIFIC"}
              content={
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 10px 15px 10px",
                    minHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  <h5
                    style={{
                      margin: "0px 0px 5px 0px",
                      color: "#fff",
                      fontSize: "17px",
                      fontWeight: "700",
                      textAlign: "start",
                    }}
                  >
                    Permisos específicos
                  </h5>
                  <p
                    style={{
                      margin: "0px 0px 15px 0px",
                      color: "#fff",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Selecciona los permisos específicos que deseas asignar al
                    usuario a continuación:
                  </p>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <RolesComponent
                      width="70%"
                      immutableRoles={[]}
                      currentRoles={currentRoles}
                      predeterminedRoles={roleOptions}
                      loading={roleOptionsLoading}
                      visibility={"visible"}
                      darkMode
                      dontShowButtons
                    />
                    <div
                      className="flex-col"
                      style={{
                        width: "30%",
                        alignItems: "start",
                      }}
                    >
                      {currentRoles.length > 0 && (
                        <FormControlLabel
                          style={{
                            color: "#fff",
                            width: "90%",
                            margin: "5px 0 5px 0px",
                            fontFamily: "Open Sans",
                          }}
                          control={
                            <Checkbox
                              style={{ color: "#fff", alignSelf: "start" }}
                              checked={singleUserCreateRoleProfileFromRoles}
                              onChange={() => {
                                if (!singleUserCreateRoleProfileFromRoles) {
                                  setNewRoleProfile({
                                    clientId: "",
                                    description: "",
                                    name: "",
                                    roles: [],
                                  });
                                } else {
                                  setNewRoleProfile(undefined);
                                }

                                setSingleUserCreateRoleProfileFromRoles(
                                  (prev) => !prev
                                );
                              }}
                            />
                          }
                          label={
                            <span
                              style={{
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#fff",
                              }}
                            >
                              ¿Guardar como rol de permisos?
                            </span>
                          }
                        />
                      )}
                      {currentRoles.length > 0 &&
                        singleUserCreateRoleProfileFromRoles && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginTop: "12px",
                              width: "80%",
                              alignSelf: "center",
                            }}
                          >
                            <label
                              htmlFor="name"
                              style={{
                                width: "100%",
                                marginRight: "10px",
                                alignSelf: "center",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "start",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "13px",
                                  color: "#fff",
                                  fontWeight: "500",
                                  textAlign: "start",
                                  margin: "0 0 2px 2px",
                                }}
                              >
                                Nombre
                              </p>
                              <input
                                onChange={(e) => {
                                  setNewRoleProfile({
                                    ...newRoleProfile!,
                                    name: e.target.value || "",
                                  });
                                }}
                                id="name"
                                name="name"
                                type="text"
                                placeholder="Nombre del rol"
                                value={newRoleProfile?.name || ""}
                                style={{
                                  border: "1px solid rgba(255,255,255,0.5)",
                                  borderRadius: "6px",
                                  background: "transparent",
                                  padding: "8px 8px 8px 8px",
                                  minHeight: "24px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  textAlign: "start",
                                  color: "#fff",
                                  width: "100%",
                                }}
                              />
                            </label>
                            {roleProfileNameError() && (
                              <p
                                style={{
                                  fontSize: "11px",
                                  textAlign: "start",
                                  margin: "0 0 2px 2px",
                                  fontWeight: "500",
                                  color: "#cf4259",
                                }}
                              >
                                {roleProfileNameError()}
                              </p>
                            )}
                          </div>
                        )}
                      {currentRoles.length > 0 &&
                        singleUserCreateRoleProfileFromRoles && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginBottom: "15px",
                              marginTop: "5px",
                              width: "83%",
                              alignSelf: "center",
                            }}
                          >
                            <label
                              htmlFor="descripcion"
                              style={{
                                width: "100%",
                                marginRight: "10px",
                                alignSelf: "center",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "start",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "13px",
                                  color: "#fff",
                                  fontWeight: "500",
                                  textAlign: "start",
                                  margin: "0 0 2px 2px",
                                }}
                              >
                                Descripción
                              </p>
                              <input
                                onChange={(e) => {
                                  setNewRoleProfile({
                                    ...newRoleProfile!,
                                    description: e.target.value || "",
                                  });
                                }}
                                id="descripcion"
                                name="descripcion"
                                type="text"
                                placeholder="Opcional"
                                value={newRoleProfile?.description || ""}
                                style={{
                                  border: "1px solid rgba(255,255,255,0.5)",
                                  borderRadius: "6px",
                                  background: "transparent",
                                  padding: "8px 8px 8px 8px",
                                  minHeight: "24px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                  textAlign: "start",
                                  color: "#fff",
                                  width: "100%",
                                }}
                              />
                            </label>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              }
              barColor="#1A617D"
              contentColor="rgb(61, 105, 122)"
              onClickFunction={() => {
                if (singleUserCreateRolesOption === "SPECIFIC") {
                  setSingleUserCreateRolesOption("NONE");
                }
                setSingleUserCreateRolesOption("SPECIFIC");
              }}
            />
            {roleProfiles && roleProfiles.length > 0 && (
              <ExpandibleContent
                title={"Roles"}
                isActive={singleUserCreateRolesOption === "ROLE_PROFILE"}
                content={
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      padding: "0 10px 15px 10px",
                      minHeight: "200px",
                    }}
                  >
                    <h5
                      style={{
                        margin: "0px",
                        color: "#fff",
                        fontSize: "17px",
                        fontWeight: "700",
                        textAlign: "start",
                      }}
                    >
                      Roles
                    </h5>
                    <p
                      style={{
                        margin: "0px",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Selecciona un rol de permisos predefinido para el usuario.
                      Puedes crear un nuevo rol en la sección de roles
                    </p>
                    {singleUserCreateRoleProfile()}
                  </div>
                }
                barColor="#1A617D"
                contentColor="rgb(29, 72, 89)"
                onClickFunction={() => {
                  if (singleUserCreateRolesOption === "ROLE_PROFILE") {
                    setSingleUserCreateRolesOption("NONE");
                  }
                  setSingleUserCreateRolesOption("ROLE_PROFILE");
                }}
              />
            )}
            <div
              className="flex-row"
              style={{
                width: "80%",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginTop: "10px",
                alignSelf: "center",
              }}
            >
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setSingleUserCreateRolesOption("NONE");
                  setSingleUserCreateStep(0);
                  dispatch(resetRoleProfiledata());
                  dispatch(emptyGeneratedPassword());
                }}
                className="flex-col text-medium text-bold"
                style={{
                  background: "transparent",
                  width: "35%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "1px solid #1A617D",
                  color: "#1A617D",
                }}
              >
                Volver
              </button>
              <button
                disabled={
                  !canCreateSingleUser() || createUserLoading === "pending"
                }
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    currentRoles.length > 0 &&
                    singleUserCreateRoleProfileFromRoles
                  ) {
                    dispatch(createRoleProfile(newRoleProfile!)).then((x) => {
                      if (x.meta.requestStatus === "fulfilled") {
                        let payload = x.payload as RoleProfile;
                        setNewRoleProfile(undefined);
                        dispatch(getRoleProfiles());
                        setSingleUserCreateRoleProfileFromRoles(false);
                        setSingleUserCreate({
                          ...singleUserCreate,
                          roleProfileId: payload.id,
                        });
                        let req: CreateUserRequest = {
                          ...singleUserCreate,
                          roleProfileId: payload.id,
                        };
                        dispatch(createUser(req)).then((x) => {
                          if (x.meta.requestStatus === "fulfilled") {
                            dispatch(resetRoleProfiledata());
                            dispatch(
                              getFilteredUsers({ ...currentFilteredRequest })
                            );
                            setSingleUserCreateStep(2);
                          }
                        });
                      }
                    });
                  } else {
                    dispatch(createUser(singleUserCreate)).then((x) => {
                      if (x.meta.requestStatus === "fulfilled") {
                        dispatch(
                          getFilteredUsers({ ...currentFilteredRequest })
                        );
                        setSingleUserCreateStep(2);
                      }
                    });
                  }
                }}
                className="flex-col text-medium text-bold primary-color"
                style={{
                  background: "#1A617D",
                  width: "35%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "none",
                }}
              >
                {createUserLoading === "pending" ||
                rpCreationLoading === "pending" ? (
                  <ClipLoader color="white" size={"20px"} />
                ) : (
                  "Crear usuario"
                )}
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            {" "}
            <div
              className="text-medium text-normal"
              style={{
                color: "black",
                marginBottom: "10px",
                paddingLeft: "5%",
                paddingRight: "5%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h5 className="text-medium text-normal">
                Se ha creado de forma exitosa el usuario. A continuación se
                muestra la contraseña que se generó para este usuario.
              </h5>
              <div
                style={{
                  border: "0.5px solid  rgba(0,0,0)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "5px 2px 5px 2px",
                  margin: "4px 2px 10px 2px",
                }}
              >
                <h6
                  style={{
                    margin: "0px 5px 0px 5px",
                    textAlign: "center",
                    fontSize: "22px",
                  }}
                >
                  {createUserPassword}
                </h6>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    try {
                      if (createUserPassword) {
                        navigator.clipboard.writeText(createUserPassword);
                        setCopied(true);
                      }
                    } catch {
                      setCopied(false);
                    }
                  }}
                  style={{
                    border: "none",
                    background: "transparent",
                    fontWeight: "700",
                  }}
                >
                  {copied ? "Copiado" : "Copiar"}
                </button>
              </div>
              <h5 className="text-medium text-normal">
                Se le pedirá al usuario que la restablesca en el primer inicio
                de sesión
              </h5>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setSingleUserCreate({
                    name: "",
                    email: "",
                    phoneNumber: "",
                    identification: "",
                    password: "",
                    roles: [],
                    roleProfileId: "",
                    userName: "",
                    userId: "",
                    setAsesor: undefined,
                  });
                  setSingleUserCreateErrors({
                    emailError: "",
                    nameError: "",
                    identificationError: "",
                    passwordError: "",
                    phoneNumberError: "",
                  });
                  setSingleUserCreateRoleProfileFromRoles(false);
                  setSingleUserPasswordRandom(true);
                  setMultipleUserPasswordRandom(true);
                  setSingleUserCreateStep(0);
                  setSingleUserCreateRolesOption("NONE");
                  dispatch(resetRoleProfiledata());
                  setNewRoleProfile(undefined);
                  setModalCreateUserOpen(false);
                  dispatch(emptyGeneratedPassword());
                }}
                className="flex-col text-medium text-bold"
                style={{
                  background: "#1A617D",
                  width: "35%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  marginTop: "10px",
                  border: "1px solid #1A617D",
                  color: "#fff",
                }}
              >
                Finalizar
              </button>
            </div>
          </div>
        );
      default:
        return <></>;
    }
  };

  const canCreateOrUpdateRoleProfile = () => {
    if (rpCreationLoading === "pending") {
      return false;
    }
    if (newRoleProfile === undefined) {
      return false;
    }
    if (newRoleProfile.name.length === 0) {
      return false;
    }
    // if other roles have a name like the one we are trying to create
    // return false
    roleProfiles.forEach((role) => {
      if (role.name === newRoleProfile.name) {
        return false;
      }
    });
    if (currentRoles.length === 0) {
      return false;
    }
    return true;
  };

  const roleProfileNameError = () => {
    if (newRoleProfile === undefined) {
      return "error";
    }
    roleProfiles.forEach((role) => {
      if (role.name === newRoleProfile.name) {
        return "Ya existe un rol con ese nombre";
      }
    });
    return "";
  };

  const buttonProfileCreation = () => {
    if (rpCreationLoading === "pending") {
      return <ClipLoader color={"#fff"} loading={true} size={20} />;
    } else {
      if (newRoleProfile) {
        if (newRoleProfile.id) {
          return "Actualizar";
        } else {
          return "Crear";
        }
      } else {
        ("Intentar de nuevo");
      }
    }
  };

  const nameSortIcon = () => {
    if (currentFilteredRequest.sortType === undefined) {
      return (
        <SortAlphaAsc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    }
    if (
      currentFilteredRequest.sortType === "NAME" &&
      !currentFilteredRequest.sortDesc
    ) {
      return (
        <SortAlphaAsc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    } else if (
      currentFilteredRequest.sortType === "NAME" &&
      currentFilteredRequest.sortDesc
    ) {
      return (
        <SortAlphaDesc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    } else {
      return (
        <SortAlphaAsc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    }
  };
  const emailSortIcon = () => {
    if (
      currentFilteredRequest.sortType === "EMAIL" &&
      !currentFilteredRequest.sortDesc
    ) {
      return (
        <SortAlphaAsc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    } else if (
      currentFilteredRequest.sortType === "EMAIL" &&
      currentFilteredRequest.sortDesc
    ) {
      return (
        <SortAlphaDesc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    } else {
      return (
        <SortAlphaAsc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    }
  };

  const creationDateSortIcon = () => {
    if (
      currentFilteredRequest.sortType === "CREATION_DATE" &&
      !currentFilteredRequest.sortDesc
    ) {
      return (
        <SortAsc height={"20px"} width={"20px"} style={{ marginLeft: "5px" }} />
      );
    } else if (
      currentFilteredRequest.sortType === "CREATION_DATE" &&
      currentFilteredRequest.sortDesc
    ) {
      return (
        <SortDesc
          height={"20px"}
          width={"20px"}
          style={{ marginLeft: "5px" }}
        />
      );
    } else {
      return (
        <SortAsc height={"20px"} width={"20px"} style={{ marginLeft: "5px" }} />
      );
    }
  };

  const changeSort = (sortType: "NAME" | "EMAIL" | "CREATION_DATE") => {
    if (currentFilteredRequest.sortType === sortType) {
      dispatch(
        changeCurrentFilters({
          ...currentFilteredRequest,
          sortDesc: !currentFilteredRequest.sortDesc,
          sortType: sortType,
        })
      );
    } else {
      dispatch(
        changeCurrentFilters({
          ...currentFilteredRequest,
          sortDesc: false,
          sortType: sortType,
        })
      );
    }
  };

  const showRoleProfiles = () => {
    const roleProfilesList: JSX.Element[] = [];
    if (roleProfiles && roleProfiles.length > 0) {
      let roleProfilesData = roleProfiles.map((roleProfile) => {
        return (
          <div
            className="list-hover-gray"
            key={roleProfile.id}
            style={{
              padding: "5px 5px",
              border: "1px solid #1A617D",
              borderRadius: "8px",
              display: "flex",
              minWidth: "350px",
              flexDirection: "row",
              cursor: "pointer",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "150px",
              maxHeight: "150px",
            }}
            onClick={() => {
              dispatch(setCurrentRoles(roleProfile.roles));
              setNewRoleProfile(roleProfile);
              setModalRoleCreateOpen(true);
              setModalRoleProfilesOpen(false);
            }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", width: "70%" }}
            >
              <p style={{ margin: "0px", color: "#000000", fontSize: "10px" }}>
                Nombre
              </p>
              <p
                style={{
                  margin: "2px 0 5px 0",
                  color: "#000000",
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                {roleProfile.name}
              </p>
              <p style={{ margin: "0px", color: "#000000", fontSize: "10px" }}>
                Descripción
              </p>
              <p
                style={{
                  margin: "2px 0 5px 0",
                  color: "#000000",
                  fontSize: "15px",
                }}
              >
                {roleProfile.description || "Sin descripción"}
              </p>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <p
                style={{
                  margin: "0px",
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                Ver detalle
              </p>
            </div>
          </div>
        );
      });
      roleProfilesList.push(...roleProfilesData);
    }
    const createRoleProfileButton = (
      <div
        className="list-hover-gray"
        style={{
          padding: "5px 5px",
          border: "1px solid #1A617D",
          borderRadius: "8px",
          display: "flex",
          minWidth: "350px",
          flexDirection: "row",
          cursor: "pointer",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "150px",
          maxHeight: "150px",
        }}
        onClick={() => {
          setNewRoleProfile({
            name: "",
            description: "",
            roles: [],
            clientId: "",
          });
          setModalRoleCreateOpen(true);
          setModalRoleProfilesOpen(false);
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p
            style={{
              margin: "2px 0 5px 0",
              color: "#000000",
              fontSize: "14px",
            }}
          >
            Crear nuevo rol de permisos
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AddIcon height={"25px"} width={"25px"} style={{}} />
          <p style={{ margin: "0px", color: "#000000", fontSize: "8px" }}>
            Crear
          </p>
        </div>
      </div>
    );
    roleProfilesList.push(createRoleProfileButton);
    return roleProfilesList;
  };

  const Pagination = () => {
    const { records, pageNumbers, setActivePage, setRecordsPerPage } =
      usePagination({
        activePage: currentPage + 1,
        recordsPerPage: currentFilteredRequest.pageSize || 10,
        totalRecordsLength:
          currentNumPages * (currentFilteredRequest.pageSize || 10),
        offset: 1,
        navCustomPageSteps: { prev: 5, next: 5 },
        permanentFirstNumber: true,
        permanentLastNumber: true,
      });

    function updateActivePage(pageNumber: number | false) {
      pageNumber && dispatch(changePageState(pageNumber - 1));
      pageNumber && setActivePage(pageNumber);
    }

    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginLeft: "3%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <select
            style={{
              width: "50px",
              height: "30px",
              background: "#0a2a39",
              color: "white",
              border: "none",
              borderRadius: "8px",
              marginRight: "5px",
            }}
            value={currentFilteredRequest.pageSize || 10}
            onChange={(e) => {
              dispatch(
                changeCurrentFilters({
                  ...currentFilteredRequest,
                  pageSize: parseInt(e.target.value),
                })
              );
              setRecordsPerPage(parseInt(e.target.value));
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
          <p style={{ fontSize: "13px", color: "white", margin: "0 0 0 3px " }}>
            Registros por página
          </p>
        </div>
        <nav role="navigation" aria-label="Paginación">
          <ul className="pagination">
            <PaginationItem
              label={`Goto first page ${pageNumbers.firstPage}`}
              onClick={() => updateActivePage(pageNumbers.firstPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&laquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto previous page ${pageNumbers.previousPage}`}
              onClick={() => updateActivePage(pageNumbers.previousPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&lsaquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto first page ${pageNumbers.firstPage}`}
              active={pageNumbers.firstPage === pageNumbers.activePage}
              onClick={() => updateActivePage(pageNumbers.firstPage)}
            >
              {pageNumbers.firstPage}
            </PaginationItem>

            {pageNumbers.customPreviousPage && (
              <PaginationItem
                label={`Goto page ${pageNumbers.customPreviousPage}`}
                onClick={() => updateActivePage(pageNumbers.customPreviousPage)}
              >
                &middot;&middot;&middot;
              </PaginationItem>
            )}

            {pageNumbers.navigation.map((navigationNumber) => {
              const isFirstOrLastPage =
                navigationNumber === pageNumbers.firstPage ||
                navigationNumber === pageNumbers.lastPage;

              return isFirstOrLastPage ? null : (
                <PaginationItem
                  label={`Goto page ${navigationNumber}`}
                  key={navigationNumber}
                  active={navigationNumber === pageNumbers.activePage}
                  onClick={() => updateActivePage(navigationNumber)}
                >
                  {navigationNumber}
                </PaginationItem>
              );
            })}

            {pageNumbers.customNextPage && (
              <PaginationItem
                label={`Goto page ${pageNumbers.customNextPage}`}
                onClick={() => updateActivePage(pageNumbers.customNextPage)}
              >
                &middot;&middot;&middot;
              </PaginationItem>
            )}

            {pageNumbers.firstPage !== pageNumbers.lastPage && (
              <PaginationItem
                label={`Goto last page ${pageNumbers.lastPage}`}
                active={pageNumbers.lastPage === pageNumbers.activePage}
                onClick={() => updateActivePage(pageNumbers.lastPage)}
              >
                {pageNumbers.lastPage}
              </PaginationItem>
            )}

            <PaginationItem
              label={`Goto next page ${pageNumbers.nextPage}`}
              onClick={() => updateActivePage(pageNumbers.nextPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&rsaquo;</p>
            </PaginationItem>

            <PaginationItem
              label={`Goto last page ${pageNumbers.lastPage}`}
              onClick={() => updateActivePage(pageNumbers.lastPage)}
            >
              <p style={{ fontSize: "25px", margin: "0px" }}>&raquo;</p>
            </PaginationItem>
          </ul>
        </nav>
        <div style={{ height: "10px", width: "10px" }}></div>
      </div>
    );
  };

  useEffect(() => {
    dispatch(resetOtherUserData());
    dispatch(changeCurrentFilters());
    dispatch(getRoleProfiles());
    if (roleOptions.length === 0 && roleOptionsLoading === "idle") {
      dispatch(getRoleOptions());
    }
  }, []);

  useEffect(() => {
    if (createUserError) {
      setSingleUserCreateRolesOption("NONE");
    }
  }, [createUserError, rpCreationError]);

  useEffect(() => {
    if (activeComponent !== "Users") {
      dispatch(changeActiveComponent("Users"));
    }

    dispatch(getFilteredUsers({ ...currentFilteredRequest }));
    return () => {};
  }, [currentPage, activeComponent, currentFilteredRequest]);

  return (
    <LoadingOverlay
      active={loadingStatus === "pending"}
      spinner={<ClipLoader color="white" size="150px" />}
    >
      <Modal
        isOpen={modalCreateUserOpen}
        style={customStylesModalCreateUser}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setMultiple(false);
          setMultipleUserCreate([]);
          setErrorMultipleUserCreate([]);
          setSingleUserCreate({
            name: "",
            email: "",
            phoneNumber: "",
            identification: "",
            password: "",
            roles: [],
            roleProfileId: "",
            userName: "",
            userId: "",
            setAsesor: undefined,
          });
          setSingleUserCreateRoleProfileFromRoles(false);
          setSingleUserCreateErrors({
            emailError: "",
            nameError: "",
            identificationError: "",
            passwordError: "",
            phoneNumberError: "",
          });
          setMultipleUserForcedPassword({
            password: undefined,
            passwordError: "",
          });
          setSingleUserPasswordRandom(true);
          setMultipleUserPasswordRandom(true);
          setSingleUserCreateStep(0);
          setSingleUserCreateRolesOption("NONE");
          dispatch(resetRoleProfiledata());
          setNewRoleProfile(undefined);
          dispatch(emptyGeneratedPassword());
          setModalCreateUserOpen(false);
        }}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Creación de usuarios
          </div>
          {singleUserCreateStep === 0 && multipleUserCreate.length === 0 && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                margin: "10px 0",
              }}
            >
              <p
                style={{
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                A continuación puedes elegir si vas a crear a un usuario, o
                crear múltiples a través de un archivo Excel.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "50%",
                  justifyContent: "space-evenly",
                  alignSelf: "center",
                }}
              >
                <button
                  onClick={() => setMultiple(false)}
                  style={{
                    width: "150px",
                    height: "30px",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    border: multiple ? "1px solid rgb(9, 39, 51)" : "none",
                    background: multiple ? "transparent" : "rgb(9, 39, 51)",
                    color: multiple ? "rgb(9, 39, 51)" : "white",
                    fontWeight: "600",
                  }}
                >
                  Solo uno
                </button>
                <button
                  onClick={() => setMultiple(true)}
                  style={{
                    width: "150px",
                    height: "30px",
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    border: multiple ? "none" : "1px solid rgb(9, 39, 51)",
                    background: multiple ? "rgb(9, 39, 51)" : "transparent",
                    color: multiple ? "white" : "rgb(9, 39, 51)",
                    fontWeight: "600",
                  }}
                >
                  Múltiples
                </button>
              </div>
            </div>
          )}
          {multiple ? multipleUserCreationModule() : singleUserCreationModule()}
        </div>
      </Modal>
      <Modal
        isOpen={modalRoleProfilesOpen}
        style={customStylesModalCreateUser}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setModalRoleProfilesOpen(false);
        }}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Roles
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              margin: "10px 0",
            }}
          >
            {roleProfiles && roleProfiles.length > 0 ? (
              <p
                style={{
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "500",
                }}
              >
                A continuación se ven los roles actuales, seleccionelos para ver
                en detalle, o puede crear otro rol.
              </p>
            ) : (
              <p
                style={{
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "500",
                }}
              >
                Aquí podrá ver los roles de permisos, para crear uno nuevo
                seleccione la opción a continuación.
              </p>
            )}
          </div>
          <div
            style={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(350px, 2fr))",
              gap: "12px",
              overflow: "auto",
              alignItems: "center",
              maxHeight: "300px",
              marginBottom: "10px",
            }}
          >
            {showRoleProfiles()}
          </div>
          <div
            className="flex-row"
            style={{
              width: "80%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <button
              disabled={false}
              onClick={(e) => {
                e.preventDefault();
                setModalRoleProfilesOpen(false);
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "35%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              Cerrar ventana
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={modalRoleCreateOpen}
        style={customStylesModalCreateUser}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setModalRoleProfilesOpen(true);
          setModalRoleCreateOpen(false);
          setNewRoleProfile(undefined);
          dispatch(resetRoleProfiledata());
        }}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Creación de un rol de permisos
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              margin: "10px 0 0 0",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "black",
                fontWeight: "500",
              }}
            >
              Ingrese la siguiente información y seleccione los permisos que
              desea que este rol tenga.
            </p>
          </div>
          <div
            className="flex-row"
            style={{
              width: "80%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "12px",
                marginBottom: "15px",
                width: "50%",
                alignSelf: "center",
              }}
            >
              <label
                htmlFor="name"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  alignSelf: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "start",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    color: "#000",
                    fontWeight: "500",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                  }}
                >
                  Nombre
                </p>
                <input
                  onChange={(e) => {
                    setNewRoleProfile({
                      ...newRoleProfile!,
                      name: e.target.value || "",
                    });
                  }}
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Nombre del rol"
                  value={newRoleProfile?.name || ""}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 8px 8px 8px",
                    minHeight: "24px",
                    fontSize: "12px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />
              </label>
              {roleProfileNameError() && (
                <p
                  style={{
                    fontSize: "11px",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                    fontWeight: "500",
                    color: "#cf4259",
                  }}
                >
                  {roleProfileNameError()}
                </p>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "12px",
                marginBottom: "15px",
                width: "50%",
                alignSelf: "center",
              }}
            >
              <label
                htmlFor="descripcion"
                style={{
                  width: "100%",
                  marginRight: "10px",
                  alignSelf: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "start",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    color: "#000",
                    fontWeight: "500",
                    textAlign: "start",
                    margin: "0 0 2px 2px",
                  }}
                >
                  Descripción
                </p>
                <input
                  onChange={(e) => {
                    setNewRoleProfile({
                      ...newRoleProfile!,
                      description: e.target.value || "",
                    });
                  }}
                  id="descripcion"
                  name="descripcion"
                  type="text"
                  placeholder="Opcional"
                  value={newRoleProfile?.description || ""}
                  style={{
                    border: "1px solid rgba(0,0,0,0.5)",
                    borderRadius: "6px",
                    background: "transparent",
                    padding: "8px 8px 8px 8px",
                    minHeight: "24px",
                    fontSize: "12px",
                    fontWeight: "500",
                    textAlign: "start",
                    color: "#000",
                    width: "100%",
                  }}
                />
              </label>
            </div>
          </div>
          <RolesComponent
            width="75%"
            immutableRoles={newRoleProfile?.roles || []}
            currentRoles={currentRoles}
            predeterminedRoles={roleOptions}
            loading={roleOptionsLoading}
            visibility={"visible"}
            darkMode
            dontShowButtons
          />
          {rpCreationError && (
            <p
              style={{
                fontSize: "13px",
                color: "#cf4259",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              {rpCreationError}
            </p>
          )}
          <div
            className="flex-row"
            style={{
              width: "90%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setModalRoleProfilesOpen(true);
                setModalRoleCreateOpen(false);
                setNewRoleProfile(undefined);
                setSingleUserPasswordRandom(true);
                dispatch(resetRoleProfiledata());
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cancelar
            </button>
            {newRoleProfile && newRoleProfile.id && (
              <button
                disabled={
                  !canCreateOrUpdateRoleProfile() ||
                  rpCreationLoading === "pending"
                }
                onClick={(e) => {
                  e.preventDefault();
                  if (newRoleProfile) {
                    if (newRoleProfile.id) {
                      dispatch(deleteRoleProfile(newRoleProfile.id)).then(
                        (x) => {
                          if (x.meta.requestStatus === "fulfilled") {
                            setModalRoleProfilesOpen(true);
                            setModalRoleCreateOpen(false);
                            setNewRoleProfile(undefined);
                            dispatch(resetRoleProfiledata());
                            dispatch(getRoleProfiles());
                          }
                        }
                      );
                    }
                  }
                }}
                className="flex-col text-medium text-bold primary-color"
                style={{
                  background: "#1A617D",
                  width: "30%",
                  height: "30px",
                  textAlign: "center",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  border: "none",
                }}
              >
                {rpCreationLoading === "pending" ? (
                  <ClipLoader color="white" size={"20px"} />
                ) : (
                  "Eliminar"
                )}
              </button>
            )}
            <button
              disabled={!canCreateOrUpdateRoleProfile()}
              onClick={(e) => {
                e.preventDefault();
                if (newRoleProfile) {
                  if (newRoleProfile.id) {
                    dispatch(updateRoleProfile(newRoleProfile)).then((x) => {
                      if (x.meta.requestStatus === "fulfilled") {
                        setModalRoleProfilesOpen(true);
                        setModalRoleCreateOpen(false);
                        setNewRoleProfile(undefined);
                        dispatch(resetRoleProfiledata());
                        dispatch(getRoleProfiles());
                      }
                    });
                  } else {
                    dispatch(createRoleProfile(newRoleProfile)).then((x) => {
                      if (x.meta.requestStatus === "fulfilled") {
                        setModalRoleProfilesOpen(true);
                        setModalRoleCreateOpen(false);
                        setNewRoleProfile(undefined);
                        dispatch(resetRoleProfiledata());
                        dispatch(getRoleProfiles());
                      }
                    });
                  }
                }
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {buttonProfileCreation()}
            </button>
          </div>
        </div>
      </Modal>{" "}
      <Modal
        isOpen={showDeactivateModal}
        style={customStylesModalCreateUser}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setShowDeactivateModal(false);
        }}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Cambiar estado de usuarios
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              margin: "10px 0 0 0",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                color: "black",
                fontWeight: "500",
              }}
            >
              ¿Estás seguro de cambiar el estado de estos usuarios? <br />
              <span style={{ fontWeight: "bolder", fontSize: "11px" }}>
                (Si los desactivas, no tendrán acceso a la plataforma pero los
                podrás activar en cualquier otro momento)
              </span>
              <br />
              <span style={{ fontSize: "14px" }}>
                A continuación puedes ver como van a cambiar los siguientes
                usuarios
              </span>
            </p>
            {changeMultipleUsersError && (
              <p
                style={{
                  color: "rgb(212, 0, 11)",
                  fontSize: "14px",
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                {changeMultipleUsersError}
              </p>
            )}
          </div>
          <div
            style={{
              width: "100%",
              height: "100px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <table style={{ width: "100%" }}>
              <thead>
                <tr style={{ fontSize: "12px" }}>
                  <th></th>
                  <th>Nombre</th>
                  <th>Correo</th>
                  <th>Estado Actual</th>
                  <th>Estado Nuevo</th>
                </tr>
              </thead>
              <tbody>
                {selectedUsers.map((user) => {
                  return (
                    <tr key={user.email} style={{ fontSize: "14px" }}>
                      <td></td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.active ? "Activo" : "Inactivo"}</td>
                      <td>{user.active ? "Inactivo" : "Activo"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div
            className="flex-row"
            style={{
              width: "90%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowDeactivateModal(false);
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cancelar
            </button>
            <button
              disabled={changeMultipleUsersLoading === "pending"}
              onClick={(e) => {
                e.preventDefault();
                const userIds = selectedUsers.map((user) => user.id);
                dispatch(toggleMultipleUserStatus(userIds)).then((x) => {
                  if (x.meta.requestStatus === "fulfilled") {
                    setShowDeactivateModal(false);
                    setSelectedUsers([]);
                    dispatch(resetChangeUserData());
                    dispatch(getFilteredUsers({ ...currentFilteredRequest }));
                  }
                });
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {changeMultipleUsersLoading === "pending" ? (
                <ClipLoader color="white" size={"20px"} />
              ) : (
                "Confirmar"
              )}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={showDeleteModal}
        style={customStylesModalCreateUser}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => {
          setShowDeleteModal(false);
        }}
      >
        <div className="flex-col" style={{ alignItems: "center" }}>
          <div
            className="text-large text-bold"
            style={{ textAlign: "center", fontSize: "18px" }}
          >
            Eliminar usuarios
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              margin: "10px 0 0 0",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                color: "black",
                fontWeight: "500",
              }}
            >
              ¿Estás seguro de eliminar estos usuarios? <br />
              <span style={{ fontWeight: "bolder", fontSize: "11px" }}>
                (Si los eliminas, no tendrán acceso a la plataforma y el nombre
                de usuario queda disponible para crear. <br />
                Esta acción no se puede revertir)
              </span>
            </p>
            {changeMultipleUsersError && (
              <p
                style={{
                  color: "rgb(212, 0, 11)",
                  fontSize: "14px",
                  textAlign: "center",
                  fontWeight: "600",
                }}
              >
                {changeMultipleUsersError}
              </p>
            )}
          </div>
          <div
            style={{
              width: "100%",
              height: "100px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <table style={{ width: "100%" }}>
              <thead>
                <tr style={{ fontSize: "12px" }}>
                  <th></th>
                  <th>Nombre</th>
                  <th>Correo</th>
                  <th>Identificación</th>
                  <th>Teléfono</th>
                </tr>
              </thead>
              <tbody>
                {selectedUsers.map((user) => {
                  return (
                    <tr key={user.email} style={{ fontSize: "14px" }}>
                      <td></td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.identification}</td>
                      <td>{user.phoneNumber}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div
            className="flex-row"
            style={{
              width: "90%",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "15px",
            }}
          >
            <button
              onClick={(e) => {
                e.preventDefault();
                setShowDeleteModal(false);
              }}
              className="flex-col text-medium text-bold"
              style={{
                background: "transparent",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "1px solid #1A617D",
                color: "#1A617D",
              }}
            >
              Cancelar
            </button>
            <button
              disabled={changeMultipleUsersLoading === "pending"}
              onClick={(e) => {
                e.preventDefault();
                const userIds = selectedUsers.map((user) => user.id);
                dispatch(deleteMultipleUser(userIds)).then((x) => {
                  if (x.meta.requestStatus === "fulfilled") {
                    setShowDeleteModal(false);
                    setSelectedUsers([]);
                    dispatch(resetChangeUserData());
                    dispatch(getFilteredUsers({ ...currentFilteredRequest }));
                  }
                });
              }}
              className="flex-col text-medium text-bold primary-color"
              style={{
                background: "#1A617D",
                width: "30%",
                height: "30px",
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                border: "none",
              }}
            >
              {changeMultipleUsersLoading === "pending" ? (
                <ClipLoader color="white" size={"20px"} />
              ) : (
                "Confirmar"
              )}
            </button>
          </div>
        </div>
      </Modal>
      {usuarios && usuarios.users.length > 0 ? (
        <div className="flex-col" style={{ width: "100%", height: "100%" }}>
          <div
            className="flex-row"
            style={{
              height: "2%",
              justifyContent: "space-between",
              alignItems: "start",
              margin: "1% 1% 1% 1%",
            }}
          >
            <div
              className="text-xx-large text-bold primary-color"
              style={{ margin: "0 0 0 2%" }}
            >
              Usuarios
            </div>
          </div>

          {selectedUsers.length === 0 && (
            <div
              className="flex-row"
              style={{
                justifyContent: "space-between",
                alignItems: "start",
                margin: "1.5% 1% 1% 1%",
              }}
            >
              <button
                className="text-medium text-bold primary-color"
                style={{
                  border: "none",
                  marginRight: "1%",
                  background: "rgba(0,0,0,0.4)",
                  paddingRight: "30px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "30px",
                  borderRadius: "8px",
                  textAlign: "center",
                  width: "200px",
                  visibility:
                    roles.includes("users.create") ||
                    roles.includes("users.edit") ||
                    roles.includes("users.admin")
                      ? "visible"
                      : "collapse",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setModalRoleProfilesOpen(true);
                }}
              >
                Roles de permisos
              </button>
              <button
                className="text-medium text-bold primary-color"
                style={{
                  border: "none",
                  marginRight: "1%",
                  marginLeft: "1%",
                  background: "rgba(0,0,0,0.4)",
                  paddingRight: "30px",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "30px",
                  borderRadius: "8px",
                  textAlign: "center",
                  width: "180px",
                  visibility: roles.includes("users.create")
                    ? "visible"
                    : "collapse",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setModalCreateUserOpen(true);
                }}
              >
                Crear usuarios
              </button>
            </div>
          )}
          {selectedUsers.length > 0 &&
            (roles.includes("users.delete") ||
              roles.includes("users.admin") ||
              roles.includes("users.edit")) && (
              <div
                className="flex-row"
                style={{
                  alignItems: "start",
                  margin: "1.5% 1% 1% 1%",
                }}
              >
                {(roles.includes("users.edit") ||
                  roles.includes("users.admin")) && (
                  <button
                    className="text-medium text-bold primary-color"
                    style={{
                      border: "none",
                      marginRight: "1%",
                      background: "rgba(0,0,0,0.4)",
                      paddingRight: "30px",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "30px",
                      borderRadius: "8px",
                      textAlign: "center",
                      minWidth: "200px",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowDeactivateModal(true);
                    }}
                  >
                    Cambiar estado seleccionados
                  </button>
                )}
                {(roles.includes("users.delete") ||
                  roles.includes("users.admin")) && (
                  <button
                    className="text-medium text-bold primary-color"
                    style={{
                      border: "none",
                      marginRight: "1%",
                      marginLeft: "1%",
                      background: "rgba(0,0,0,0.4)",
                      paddingRight: "30px",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      paddingLeft: "30px",
                      borderRadius: "8px",
                      textAlign: "center",
                      minWidth: "200px",
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowDeleteModal(true);
                    }}
                  >
                    Eliminar seleccionados
                  </button>
                )}
              </div>
            )}
          {usuarios.users ? (
            <div
              className="flex-col"
              style={{ height: "85%", margin: "1% 1% 0 0 " }}
            >
              <div style={{ overflow: "auto" }}>
                <table
                  style={{
                    width: "98%",
                    borderCollapse: "collapse",
                    marginLeft: "1%",
                  }}
                >
                  <thead
                    className="text-normal text-medium primary-color-35"
                    style={{
                      background: "rgba(0,0,0,0.4)",
                      height: "30px",
                      textAlign: "center",
                    }}
                  >
                    <tr>
                      <th></th>
                      {(roles.includes("users.edit") ||
                        roles.includes("users.admin") ||
                        roles.includes("users.delete")) && (
                        <th>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Checkbox
                              style={{ color: "#FFF" }}
                              indeterminate={
                                selectedUsers.length > 0 &&
                                selectedUsers.length < usuarios.users.length
                              }
                              checked={
                                selectedUsers.length === usuarios.users.length
                              }
                              onChange={() => {
                                if (usuarios) {
                                  if (selectedUsers.length > 0) {
                                    setSelectedUsers([]);
                                  } else {
                                    setSelectedUsers(usuarios.users);
                                  }
                                }
                              }}
                            />
                          </div>
                        </th>
                      )}
                      <th>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            changeSort("NAME");
                          }}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          Nombres y Apellidos
                          {nameSortIcon()}
                        </div>
                      </th>
                      <th>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            changeSort("EMAIL");
                          }}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          Email
                          {emailSortIcon()}
                        </div>
                      </th>
                      <th>Identificación</th>
                      <th>
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            changeSort("CREATION_DATE");
                          }}
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          Fecha de creación
                          {creationDateSortIcon()}
                        </div>
                      </th>
                      <th>Último inicio de sesión</th>
                      <th>Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody
                    className="text-normal text-x-small primary-color"
                    style={{
                      background: "rgba(0,0,0,0.2)",
                      textAlign: "center",
                    }}
                  >
                    <tr>
                      <td>&nbsp;</td>{" "}
                      {(roles.includes("users.edit") ||
                        roles.includes("users.admin") ||
                        roles.includes("users.delete")) && <td></td>}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    {usuarios.users.map((usuario, i) => {
                      if (usuario.id !== userId) {
                        return (
                          <tr
                            key={i}
                            className="list-hover"
                            style={{ height: "30px", cursor: "pointer" }}
                          >
                            <td></td>
                            {(roles.includes("users.edit") ||
                              roles.includes("users.admin") ||
                              roles.includes("users.delete")) && (
                              <td>
                                {
                                  <Checkbox
                                    style={{ color: "#FFF" }}
                                    checked={
                                      selectedUsers.find(
                                        (user) => user.id === usuario.id
                                      ) !== undefined
                                    }
                                    onChange={() => {
                                      if (selectedUsers.includes(usuario)) {
                                        setSelectedUsers(
                                          selectedUsers.filter(
                                            (user) => user.id !== usuario.id
                                          )
                                        );
                                      } else {
                                        setSelectedUsers([
                                          ...selectedUsers,
                                          usuario,
                                        ]);
                                      }
                                    }}
                                  />
                                }
                              </td>
                            )}
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${usuario.id}`);
                              }}
                              style={{ textAlign: "left", paddingLeft: "10px" }}
                            >
                              {usuario.name || "NO Registra"}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${usuario.id}`);
                              }}
                              style={{ textAlign: "left", paddingLeft: "10px" }}
                            >
                              {usuario.email || "NO Registra"}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${usuario.id}`);
                              }}
                            >
                              {usuario.identification || "NO Registra"}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${usuario.id}`);
                              }}
                            >
                              {formatDateStandar(usuario.creationDate)}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${usuario.id}`);
                              }}
                            >
                              {formateDateRelativeToNow(usuario.latestLogin)}
                            </td>
                            <td
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(`${usuario.id}`);
                              }}
                            >
                              {usuario.active === true ? "Activo" : "Inactivo"}
                            </td>
                            <td></td>
                          </tr>
                        );
                      }
                    })}
                    <tr>
                      <td>&nbsp;</td>
                      {(roles.includes("users.edit") ||
                        roles.includes("users.admin") ||
                        roles.includes("users.delete")) && <td></td>}
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="flex-col" style={{ height: "70%" }}>
              <h1 className="text-huge text-bold primary-color">
                {loadingStatus === "pending"
                  ? ""
                  : "No hay más usuarios en esta página"}
              </h1>
            </div>
          )}
          <div
            className="flex-row"
            style={{
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              height: "5%",
              marginTop: "2%",
            }}
          >
            <Pagination />
          </div>
        </div>
      ) : (
        <div
          className="flex-col"
          style={{
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="text-medium text-bold primary-color"
            style={{
              border: "none",
              marginTop: "4%",
              marginRight: "1%",
              marginLeft: "1%",
              background: "rgba(0,0,0,0.4)",
              paddingRight: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "30px",
              borderRadius: "8px",
              textAlign: "center",
              width: "180px",
              visibility: roles.includes("users.create")
                ? "visible"
                : "collapse",
            }}
            onClick={(e) => {
              e.preventDefault();
              setModalCreateUserOpen(true);
            }}
          >
            Crear usuarios
          </button>
          <h1 className="text-huge text-bold primary-color">
            {loadingStatus === "pending"
              ? ""
              : "No hay más usuarios en esta página"}
          </h1>
        </div>
      )}
    </LoadingOverlay>
  );
};
